module.exports = __webpack_public_path__ + "static/noPhotoMate-3b66cd28f5961f304b720009e8032831.jpg";